<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <div v-if="showWarning" class="form-field-warn" style="right: 0 !important;">
      <label>!</label>
      <div class="form-field-warn-text">
        <div>Дата выдачи не соответствует серии паспорта</div>
      </div>
    </div>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <div class="input-group">
      <date-picker
        :id="inputId"
        :disabled="disabled"
        :value-type="dateValueType"
        :format="dateFormat"
        :disabled-date="isDisabledDate"
        v-model="inputValue"
        v-facade="dateMask"
        @input="emitValue('input', $event)"
        @change="emitValue('change', $event)"
        @blur="emitValue('change', $event)"
      />
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import datePickerConfigMixin from '../../../../mixins/application-form/datePickerConfigMixin'

export default {
  name: 'IdentificationDateOfInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    datePickerConfigMixin
  ],

  props: {
    inputLabel: {
      default: 'Дата выдачи'
    },

    inputName: {
      default: 'identification_date_of'
    }
  },

  computed: {
    inputId () {
      return `form-visitor-identification-date-of-${this.visitorIndex}`
    },

    showWarning() {
      return this.isView && this.identificationNumberNeedCheck()
    }
  },

  methods: {
    disabledDate (date) {
      return false
    },

    identificationNumberNeedCheck() {
      let identificationNumber = this.visitor.personal.identification_number
      let identificationDateOf = this.inputValue
      if (identificationNumber.length > 10 && this.russianCivilPassportSelected(this.visitorIndex) && identificationDateOf !== null) {
        let yearInSeries = identificationNumber.substring(2, 4)

        return this.checkPassportSeriesIsAccordToDate(yearInSeries, identificationDateOf)
      }

      return false
    }
  }
}
</script>
